import { Navigate } from 'react-router-dom';
import {userHasRoleOrClaims, CheckIsClient, CheckIsHighPrivilegeUser, CheckIsExternalUser} from "@/contexts/UserContext.tsx";
import {showToast} from "@/lib/use-sonner.tsx";
import {t} from "i18next";

interface ClaimProps {
    children: React.ReactElement;
    allowedClaims?: string[];
    notAllowedClaims?: string[];
    allowClients?: boolean;
}

export function CustomRouteGuard({ children, allowedClaims = [], notAllowedClaims = [], allowClients = false }: ClaimProps) {
    const isClient = CheckIsClient();
    const isHighPrivilegeUser = CheckIsHighPrivilegeUser();
    const isExternalUser = CheckIsExternalUser();
    
    console.log({allowedClaims, notAllowedClaims, isClient, isHighPrivilegeUser})
    if(isExternalUser || (!allowClients && isClient))
        return redirectToHome();

    if(allowedClaims && allowedClaims.length > 0){
        const hasAnyAllowedRole = userHasRoleOrClaims(allowedClaims);

        if (!hasAnyAllowedRole) {
            return redirectToHome();
        }

        return children;
    }
    
    if(notAllowedClaims && notAllowedClaims.length > 0){
        if (isHighPrivilegeUser) {
            return children;
        }

        const hasAnyNotAllowedRole = userHasRoleOrClaims(notAllowedClaims);

        if (hasAnyNotAllowedRole) {
            return redirectToHome();
        }

        return children;
    }
    
    return children;
}

const redirectToHome = () => {
    setTimeout(() => {
        showToast({
            title: t('Error.AccessRestricted'),
            description: t('Error.AccessRestrictedPermissionMessage'),
            variant: 'destructive'
        });
    }, 200)
    
   return <Navigate to="/" replace />
};